import { Ratelimiter, RequestHandler } from "./RequestHandler";
import AssetsMethods = require("./methods/Assets");
import AuditLogMethods = require("./methods/AuditLog");
import AutoModerationMethods = require("./methods/AutoModeration");
import BotMethods = require("./methods/Bot");
import ChannelMethods = require("./methods/Channel");
import EntitlementMethods = require("./methods/Entitlements");
import GuildMethods = require("./methods/Guild");
import GuildScheduledEventMethods = require("./methods/GuildScheduledEvent");
import GuildTemplateMethods = require("./methods/GuildTemplate");
import InteractionMethods = require("./methods/Interaction");
import InviteMethods = require("./methods/Invite");
import SkuMethods = require("./methods/Sku");
import StageInstanceMethods = require("./methods/StageInstance");
import UserMethods = require("./methods/User");
import VoiceMethods = require("./methods/Voice");
import WebhookMethods = require("./methods/Webhook");
import Endpoints = require("./Endpoints");
import Constants = require("./Constants");

import type { APIAllowedMentions } from 'discord-api-types/v10';

namespace SnowTransfer {
	export type Options = {

		baseHost: string;

		allowed_mentions: APIAllowedMentions | undefined;


		disableEveryone: boolean;

		bypassBuckets: boolean;

		retryRequests: boolean;

		retryLimit: number;
	};
}




class SnowTransfer {

	public options: SnowTransfer.Options;

	public token: string | undefined;

	public channel: ChannelMethods;

	public requestHandler: RequestHandler;

	public user: UserMethods;

	public assets: AssetsMethods;

	public webhook: WebhookMethods;

	public guild: GuildMethods;

	public guildScheduledEvent: GuildScheduledEventMethods;

	public guildTemplate: GuildTemplateMethods;

	public interaction: InteractionMethods;

	public invite: InviteMethods;

	public voice: VoiceMethods;

	public bot: BotMethods;

	public auditLog: AuditLogMethods;

	public stageInstance: StageInstanceMethods;

	public autoMod: AutoModerationMethods;

	public entitlement: EntitlementMethods;

	public sku: SkuMethods;

	public ratelimiter: Ratelimiter;






	public constructor(token?: string, options?: Partial<SnowTransfer.Options>) {
		if (typeof token === "string" && token === "") throw new Error("Missing token");
		if (token && (!token.startsWith("Bot") && !token.startsWith("Bearer"))) token = `Bot ${token}`;
		this.options = { baseHost: Endpoints.BASE_HOST, allowed_mentions: undefined, disableEveryone: false, bypassBuckets: false, retryRequests: false, retryLimit: Constants.DEFAULT_RETRY_LIMIT, ...options };
		this.token = token;
		this.ratelimiter = new Ratelimiter();
		this.requestHandler = new RequestHandler(this.ratelimiter, {
			token: this.token,
			baseHost: this.options.baseHost,
			bypassBuckets: this.options.bypassBuckets,
			retryFailed: this.options.retryRequests,
			retryLimit: this.options.retryLimit
		});
		this.channel = new ChannelMethods(this.requestHandler, this.options);
		this.user = new UserMethods(this.requestHandler);
		this.assets = new AssetsMethods(this.requestHandler);
		this.webhook = new WebhookMethods(this.requestHandler, this.options);
		this.guild = new GuildMethods(this.requestHandler);
		this.guildScheduledEvent = new GuildScheduledEventMethods(this.requestHandler);
		this.guildTemplate = new GuildTemplateMethods(this.requestHandler);
		this.interaction = new InteractionMethods(this.requestHandler, this.webhook, this.options);
		this.invite = new InviteMethods(this.requestHandler);
		this.voice = new VoiceMethods(this.requestHandler);
		this.bot = new BotMethods(this.requestHandler);
		this.auditLog = new AuditLogMethods(this.requestHandler);
		this.stageInstance = new StageInstanceMethods(this.requestHandler);
		this.autoMod = new AutoModerationMethods(this.requestHandler);
		this.entitlement = new EntitlementMethods(this.requestHandler);
		this.sku = new SkuMethods(this.requestHandler);
	}
}

export = SnowTransfer;
